import {QueryNode} from "@ispm-client/modules/query-builder/models/query-builder-config";

export class Factor {
  //factor is the whitebox
  public queryNode: QueryNode;

}
